(function () {
  'use strict';

  var modal, backdrop, loadingEl, contentEl;
  var mainImg, titleEl, priceEl, compareEl;
  var ratingEl, optionsEl, addonWrap, atcBtn, errorEl, closeBtn;

  var currentProduct = null;
  var selectedOptions = [];
  var selectedVariant = null;

  var BIRTHSTONES = {
    'january':'Garnet','february':'Amethyst','march':'Aquamarine',
    'april':'Diamond','may':'Emerald','june':'Pearl',
    'july':'Ruby','august':'Peridot','september':'Sapphire',
    'october':'Opal','november':'Topaz','december':'Turquoise'
  };

  /* ---- helpers ---- */
  function imgSrc(img) {
    if (!img) return '';
    return typeof img === 'string' ? img : (img.src || img.url || '');
  }

  function sizedUrl(src, size) {
    if (!src) return '';
    return src.replace(/(\.[^.?]+)(\?.*)?$/, '_' + size + '$1$2');
  }

  function fmtMoney(cents) {
    if (cents == null) return '';
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function optName(opt) {
    return typeof opt === 'string' ? opt : (opt && opt.name ? opt.name : '');
  }

  function gemstoneFor(val) {
    if (!val) return '';
    // If value already contains the gemstone (e.g. "January - Garnet")
    var sep = val.match(/\s[\-\u2013]\s/);
    if (sep) return val.split(sep[0])[1] || '';
    // Fall back to lookup
    var month = val.trim().toLowerCase();
    return BIRTHSTONES[month] || '';
  }

  function monthLabel(val) {
    if (!val) return val;
    var sep = val.match(/\s[\-\u2013]\s/);
    return sep ? val.split(sep[0])[0] : val;
  }

  function showError(msg) {
    if (errorEl) { errorEl.textContent = msg; errorEl.classList.add('is-visible'); }
  }

  function clearError() {
    if (errorEl) { errorEl.textContent = ''; errorEl.classList.remove('is-visible'); }
  }

  function getActiveAddon() {
    var found = null;
    document.querySelectorAll('[data-addon-upsell]').forEach(function (el) {
      if (el.__addonInst && el.__addonInst.active) found = el.__addonInst;
    });
    return found;
  }

  /* ---- init ---- */
  function init() {
    modal = document.getElementById('qb-modal');
    if (!modal) return;

    backdrop   = modal.querySelector('.qb-backdrop');
    loadingEl  = modal.querySelector('.qb-loading');
    contentEl  = modal.querySelector('.qb-content');
    mainImg    = modal.querySelector('.qb-img');
    titleEl    = modal.querySelector('.qb-title');
    priceEl    = modal.querySelector('.qb-price');
    compareEl  = modal.querySelector('.qb-compare-price');
    ratingEl   = modal.querySelector('.qb-rating');
    optionsEl  = modal.querySelector('.qb-options');
    addonWrap  = modal.querySelector('.qb-addon-wrap');
    atcBtn     = modal.querySelector('.qb-atc');
    errorEl    = modal.querySelector('.qb-error');
    closeBtn   = modal.querySelector('.qb-close');

    closeBtn.addEventListener('click', closeModal);
    backdrop.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
      if (e.key === 'Tab'    && !modal.hidden) trapFocus(e);
    });

    atcBtn.addEventListener('click', handleAddToCart);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qb-handle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      openModal(btn.dataset.qbHandle);
    });
  }

  /* ---- open / close ---- */
  function openModal(handle) {
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    loadingEl.style.display = 'flex';
    contentEl.hidden = true;
    clearError();
    if (atcBtn) { atcBtn.textContent = 'Add to Cart'; atcBtn.disabled = false; atcBtn.className = 'qb-atc'; }
    resetAddon();

    var jsonUrl = '/products/' + encodeURIComponent(handle) + '.js';
    var htmlUrl = '/products/' + encodeURIComponent(handle);

    Promise.all([
      fetch(jsonUrl).then(function (r) { if (!r.ok) throw new Error(); return r.json(); }),
      fetch(htmlUrl).then(function (r) { return r.text(); })
    ])
    .then(function (results) {
      currentProduct = results[0];
      populate(currentProduct);
      loadingEl.style.display = 'none';
      contentEl.hidden = false;
      setTimeout(function () { closeBtn && closeBtn.focus(); }, 60);
      injectAddon(results[1]);
    })
    .catch(function () {
      loadingEl.style.display = 'none';
      showError('Could not load product. Please visit the product page.');
      contentEl.hidden = false;
    });
  }

  function closeModal() {
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    currentProduct = null; selectedVariant = null; selectedOptions = [];
    resetAddon();
    document.querySelectorAll('style[data-qb-style]').forEach(function (s) { s.remove(); });
  }

  function resetAddon() {
    if (addonWrap) { addonWrap.innerHTML = ''; addonWrap.style.display = 'none'; }
  }

  /* ---- inject addon ---- */
  function injectAddon(html) {
    if (!addonWrap) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var addonEl = doc.querySelector('[data-addon-upsell]');
    if (!addonEl) return;
    var sid = addonEl.dataset.sectionId;

    var addonCssLink = doc.querySelector('link[href*="product-addon-upsell"]');
    if (addonCssLink && !document.querySelector('link[href*="product-addon-upsell"]')) {
      var lnk = document.createElement('link');
      lnk.rel = 'stylesheet'; lnk.href = addonCssLink.href;
      document.head.appendChild(lnk);
    }

    doc.querySelectorAll('style').forEach(function (s) {
      if (s.textContent.indexOf('#au-' + sid) !== -1) {
        var st = document.createElement('style');
        st.textContent = s.textContent; st.dataset.qbStyle = '1';
        document.head.appendChild(st);
      }
    });

    doc.querySelectorAll('script:not([src])').forEach(function (s) {
      if (s.textContent.indexOf('__addonUpsell') !== -1) {
        var sc = document.createElement('script');
        sc.textContent = s.textContent;
        document.body.appendChild(sc); document.body.removeChild(sc);
      }
    });

    var wrapper = doc.getElementById('au-' + sid) || addonEl;
    addonWrap.innerHTML = wrapper.outerHTML;
    addonWrap.style.display = '';

    var addonJsSrc = (doc.querySelector('script[src*="product-addon-upsell"]') || {}).src;
    if (addonJsSrc && !document.querySelector('script[src*="product-addon-upsell"]')) {
      var js = document.createElement('script');
      js.src = addonJsSrc;
      js.onload = function () { initAddonEl(addonWrap); };
      document.body.appendChild(js);
    } else {
      initAddonEl(addonWrap);
    }
  }

  function initAddonEl(wrap) {
    var el = wrap && wrap.querySelector('[data-addon-upsell]');
    if (el && window.AddonUpsell && !el.__addonInst) {
      try { el.__addonInst = new window.AddonUpsell(el); } catch (e) {}
    }
  }

  /* ---- populate ---- */
  function populate(product) {
    if (titleEl) titleEl.textContent = product.title || '';

    var imgs = product.images || [];
    if (mainImg && imgs.length) {
      var s = imgSrc(imgs[0]);
      if (s) mainImg.src = sizedUrl(s, '400x');
    }

    if (ratingEl) {
      ratingEl.innerHTML = '<div class="jdgm-widget jdgm-preview-badge" data-id="' + product.id + '"></div>';
      try { if (window.jdgm && window.jdgm.customWidgetFire) window.jdgm.customWidgetFire(); } catch(e) {}
    }

    selectedOptions = [];
    buildOptions(product);

    var variants = product.variants || [];
    var first = variants.filter(function (v) { return v.available; })[0] || variants[0] || null;
    applyVariant(first);
  }

  /* ---- options / variants ---- */
  function buildOptions(product) {
    if (!optionsEl) return;
    optionsEl.innerHTML = '';
    var opts = product.options || [];
    if (!opts.length || (opts.length === 1 && optName(opts[0]) === 'Title')) return;

    opts.forEach(function (opt, idx) {
      var name = optName(opt);
      var isBirthstone = name.toLowerCase().indexOf('birthstone') !== -1;

      var vals = [];
      (product.variants || []).forEach(function (v) {
        var val = v.options && v.options[idx];
        if (val != null && vals.indexOf(val) === -1) vals.push(val);
      });
      if (!vals.length) return;
      selectedOptions[idx] = vals[0];

      if (isBirthstone) {
        buildBirthstoneGroup(name, vals, idx);
      } else {
        buildStandardGroup(name, vals, idx);
      }
    });

    refreshAvailability();
  }

  function buildStandardGroup(name, vals, idx) {
    var group   = document.createElement('div');  group.className = 'qb-opt-group';
    var label   = document.createElement('div');  label.className = 'qb-opt-label';  label.textContent = name;
    var valWrap = document.createElement('div');  valWrap.className = 'qb-opt-values';

    vals.forEach(function (val) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'qb-opt-btn' + (val === vals[0] ? ' is-selected' : '');
      btn.textContent = val;
      btn.dataset.optIdx = idx;
      btn.dataset.optVal = val;
      btn.addEventListener('click', function () {
        selectedOptions[idx] = val;
        valWrap.querySelectorAll('.qb-opt-btn').forEach(function (b) {
          b.classList.toggle('is-selected', b.dataset.optVal === val);
        });
        var match = findVariant(selectedOptions);
        if (match) applyVariant(match);
        refreshAvailability();
      });
      valWrap.appendChild(btn);
    });

    group.appendChild(label); group.appendChild(valWrap);
    optionsEl.appendChild(group);
  }

  function buildBirthstoneGroup(name, vals, idx) {
    var group = document.createElement('div');
    group.className = 'qb-opt-group qb-birthstone-group';
    group.dataset.optIdx = idx;

    // Header label: "BIRTHSTONE | January \u2013 Garnet"
    var label = document.createElement('div');
    label.className = 'qb-opt-label qb-birthstone-label';

    function updateLabel(val) {
      var ml = monthLabel(val);
      var gem = gemstoneFor(val);
      label.innerHTML = name.toUpperCase() +
        (ml ? '<span class="qb-bs-sep"> | </span><span class="qb-bs-selection">' +
          ml + (gem ? ' \u2013 ' + gem : '') + '</span>' : '');
    }
    updateLabel(vals[0]);

    // Month grid
    var grid = document.createElement('div');
    grid.className = 'qb-bs-grid';

    vals.forEach(function (val) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'qb-bs-btn' + (val === vals[0] ? ' is-selected' : '');
      btn.textContent = monthLabel(val);
      btn.dataset.optIdx = idx;
      btn.dataset.optVal = val;
      btn.addEventListener('click', function () {
        selectedOptions[idx] = val;
        grid.querySelectorAll('.qb-bs-btn').forEach(function (b) {
          b.classList.toggle('is-selected', b.dataset.optVal === val);
        });
        updateLabel(val);
        var match = findVariant(selectedOptions);
        if (match) applyVariant(match);
        refreshAvailability();
      });
      grid.appendChild(btn);
    });

    group.appendChild(label);
    group.appendChild(grid);
    optionsEl.appendChild(group);
  }

  function refreshAvailability() {
    if (!currentProduct || !optionsEl) return;
    optionsEl.querySelectorAll('.qb-opt-btn, .qb-bs-btn').forEach(function (btn) {
      var test = selectedOptions.slice();
      test[parseInt(btn.dataset.optIdx)] = btn.dataset.optVal;
      var v = findVariant(test);
      btn.classList.toggle('is-unavailable', !v || !v.available);
    });
  }

  function findVariant(opts) {
    if (!currentProduct) return null;
    return (currentProduct.variants || []).find(function (v) {
      return (v.options || []).every(function (o, i) { return opts[i] === undefined || o === opts[i]; });
    });
  }

  function applyVariant(variant) {
    selectedVariant = variant;
    if (!variant) { if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Unavailable'; } return; }

    if (priceEl) {
      priceEl.textContent = fmtMoney(variant.price);
      priceEl.classList.toggle('is-sale', !!(variant.compare_at_price && variant.compare_at_price > variant.price));
    }
    if (compareEl) {
      var hasComp = variant.compare_at_price && variant.compare_at_price > variant.price;
      compareEl.textContent = hasComp ? fmtMoney(variant.compare_at_price) : '';
      compareEl.style.display = hasComp ? 'inline' : 'none';
    }
    if (variant.featured_image && mainImg) {
      var vs = imgSrc(variant.featured_image);
      if (vs) { mainImg.style.opacity = '0.45'; mainImg.src = sizedUrl(vs, '400x'); mainImg.onload = function () { mainImg.style.opacity = '1'; }; }
    }
    if (atcBtn) {
      atcBtn.disabled    = !variant.available;
      atcBtn.className   = 'qb-atc';
      atcBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
    clearError();
  }

  /* ---- add to cart ---- */
  function handleAddToCart() {
    if (!selectedVariant || !selectedVariant.available) return;

    atcBtn.disabled = true;
    atcBtn.className = 'qb-atc is-loading';
    atcBtn.textContent = 'Adding\u2026';
    clearError();

    var items = [{ id: selectedVariant.id, quantity: 1 }];
    var addon = getActiveAddon();
    if (addon && addon.variant) {
      items.push({ id: addon.variant.id, quantity: 1 });
      addon._pending = true;
    }

    var phEl = document.querySelector('page-header');
    var cdEl = document.querySelector('cart-drawer');
    var sEls = [phEl, cdEl].filter(Boolean);
    var sIds = sEls.map(function (el) { return el.dataset.sectionId; }).filter(Boolean);

    var go = (window.__addonOrigFetch || window.fetch).bind(window);

    go(theme.routes.cartAdd, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items,
        sections: sIds.join(','),
        sections_url: window.location.pathname
      })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (addon) addon._pending = false;

      if (data.status) {
        atcBtn.disabled = false; atcBtn.className = 'qb-atc'; atcBtn.textContent = 'Add to Cart';
        showError(data.description || data.message || 'Could not add to cart.');
        return;
      }

      if (data.sections) {
        sEls.forEach(function (el) {
          if (el.dataset.sectionId && data.sections[el.dataset.sectionId] && typeof el.updateFromCartChange === 'function') {
            el.updateFromCartChange(data.sections[el.dataset.sectionId]);
          }
        });
      }

      closeModal();

      var afterAdd = window.theme && theme.settings ? theme.settings.afterAddToCart : '';
      if (afterAdd === 'drawer') {
        var drawer = document.querySelector('.js-cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open(atcBtn);
      } else if (afterAdd === 'notification') {
        var tmpl = document.getElementById('AddedNotification');
        if (tmpl) {
          var note = tmpl.content.firstElementChild.cloneNode(true);
          note.dataset.productTitle = data.product_title || '';
          var container = document.querySelector('.pageheader--sticky') || document.body;
          container.appendChild(note);
        }
      } else if (afterAdd === 'page') {
        setTimeout(function () { window.location.href = theme.routes.cart; }, 300);
      }
    })
    .catch(function () {
      if (addon) addon._pending = false;
      atcBtn.disabled = false; atcBtn.className = 'qb-atc'; atcBtn.textContent = 'Add to Cart';
      showError('Something went wrong. Please try again.');
    });
  }

  /* ---- focus trap ---- */
  function trapFocus(e) {
    var els = Array.from(modal.querySelectorAll('button:not([disabled]),[href],input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])')).filter(function (el) { return el.offsetParent !== null; });
    if (!els.length) return;
    if (e.shiftKey) { if (document.activeElement === els[0]) { els[els.length-1].focus(); e.preventDefault(); } }
    else            { if (document.activeElement === els[els.length-1]) { els[0].focus(); e.preventDefault(); } }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
